import React from "react";
import { Tag } from "antd";

export default function GetTag(label) {
    return <Tag color={"blue"}>{label}</Tag>;
}
